export const getSceneTags = (
  source: { keywords?: string[]; worldview?: string[] } | null
): string[] => [...(source?.keywords ?? []), ...(source?.worldview ?? [])];
